import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LowerCasePipe } from '@angular/common';
import { DashboardQuerySystemJobStatusResultDto, DashboardService, JobStatus } from '@app/api/dmc';

@Component({
  selector: 'app-dashboard-system-overview',
  imports: [
    TranslatePipe,
    LowerCasePipe,
  ],
  templateUrl: './dashboard-system-overview.component.html',
  styleUrl: './dashboard-system-overview.component.css'
})
export class DashboardSystemOverviewComponent {

  public systemJobs: DashboardQuerySystemJobStatusResultDto[] = [];
  public systemLoading = true;

  protected readonly JobStatus = JobStatus;

  constructor(private readonly dashboardService: DashboardService) {
    this.dashboardService.dashboardGetSystemStatusGet().subscribe((result: any) => {
      this.systemJobs = result.results ?? [];
      this.systemLoading = false;
    });
  }

  public accentClass(job: DashboardQuerySystemJobStatusResultDto): string {
    return job.status === JobStatus.Ok ? 'bg-emerald-500' : 'bg-red-500';
  }

  public statusLabel(job: DashboardQuerySystemJobStatusResultDto): string {
    return job.status === JobStatus.Ok ? 'OK' : 'Fejl';
  }

  public statusTextClass(job: DashboardQuerySystemJobStatusResultDto): string {
    return job.status === JobStatus.Ok
      ? 'text-emerald-600 dark:text-emerald-400'
      : 'text-red-500 dark:text-red-400';
  }
}
